import { render, staticRenderFns } from "./ViewerSettingsForm.vue?vue&type=template&id=58547347&"
import script from "./ViewerSettingsForm.vue?vue&type=script&lang=ts&"
export * from "./ViewerSettingsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports